import { observer } from 'mobx-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'reactstrap';
import { Knob } from 'twyne-new.ui';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

@observer
class DefaultSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q: ''
    }
  }

  onInputChange = (q) => {
    const { onSearch } = this.props;
    this.setState({q});
    if (onSearch) {
      onSearch(q);
    }
  }

  render() {
    const { name } = this.props;
    const [ , singular ] = name;

    return (
      <div className="content-heading">
        <div className="search-form">
          <Input
            type="search"
            placeholder={`Search ${singular}`}
            bsSize="lg"
            onChange={(e) => this.onInputChange(e.target.value)}
            value={this.state.q}
          />
          <button type="submit"><FontAwesomeIcon icon="search" /></button>
        </div>
        {this.renderStatistics()}
      </div>
    );
  }

  renderStatistics = () => {
    const { name, count, showing, actives } = this.props;
    const [ plural ] = name;

    if (!count) {
      return null;
    }

    return (
      <div className="chart-heading-wrapper float-right">
        <div className={`chart-heading ${showing ? 'separator' : ''}`}>
          <span className="chart-title">Total {plural}</span>
          <span className="chart-value total">{count}</span>
        </div>
        { showing ? (
          <Knob max={count} min={0} value={showing} width={41} color="#fde345" />
        ) : null }
        { showing ? (
          <div className="chart-heading">
            <span className="chart-title">Showing</span>
            <span className="chart-value">{showing}</span>
          </div>
        ) : null }

        { actives && showing ? (
          <Knob max={showing} min={0} value={actives} width={41} color="#5ABA9D" />
        ) : null }
        { actives && showing ? (
          <div className="chart-heading">
            <span className="chart-title">Actives</span>
            <span className="chart-value">{actives}</span>
          </div>
        ) : null }
      </div>
    );
  }
}

DefaultSearch.defaultProps = {
  name: ['Datas', 'data']
}

DefaultSearch.propTypes = {
  onSearch: PropTypes.func,
  count: PropTypes.number,
  showing: PropTypes.number,
  actives: PropTypes.number,
  name: PropTypes.arrayOf(PropTypes.string)
};

export default DefaultSearch;
